export const ACTIVE_BOX_SHADOW = 'inset 0 3px 5px rgb(0 0 0 / 25%)';
